import { isEmpty, lowerCase } from "lodash";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import secureLocalStorage from "react-secure-storage";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../context/BetSlipContext";
const Parlay = ({ odds, object, handleScore, showScore, displayScore }) => {
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  const setParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlyBet;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const navigate = useNavigate();
  const [premiumDetail, setPremiumDetail] = useState([]);
  const [premiumDetail2, setPremiumDetail2] = useState({});
  useEffect(() => {
    const findMarket = (condition) => {
      return (
        odds?.find(
          (res) =>
            Number(res?.betfairEventId) == Number(object?.eventId) &&
            condition(res)
        ) || {}
      );
    };

    const gameTypeConfig = {
      soccer: {
        obj1: (res) => /1x2/i.test(res?.marketName),
        obj2: (res) => res?.marketName?.includes("Total"),
      },
      tennis: {
        obj1: (res) => res?.marketName?.includes("Winner"),
        obj2: (res) =>
          /1x2/i.test(res?.marketName) || res?.marketName === "Total games",
      },
      default: {
        obj1: (res) => res?.marketName?.includes("Winner"),
        obj2: (res) => res?.marketName === "Total",
      },
    };

    const { obj1: cond1, obj2: cond2 } =
      gameTypeConfig[object?.gameType] || gameTypeConfig.default;

    const obj1 = findMarket(cond1);
    if (!isEmpty(obj1)) setPremiumDetail(obj1);

    let obj2 = findMarket(cond2);
    if (!isEmpty(obj2)) {
      setPremiumDetail2(obj2);
    } else if (object?.gameType !== "soccer" && object?.gameType !== "tennis") {
      const fallback = odds?.filter(
        (res) =>
          res?.betfairEventId === object?.eventId &&
          !res?.marketName?.includes("Winner")
      );
      if (fallback?.length > 0) setPremiumDetail2(fallback[0]);
    }
  }, [object, odds]);

  const handelPaly = (item, res) => {
    console.log(object, "item");
    if (isEmpty(user)) {
      setToastObject({
        type: "warning",
        title: "Warning",
        message: "Please login to place your bet!",
        status: true,
      });
    } else {
      setParlyBet((current) => {
        const newObj = {
          ...item,
          sportsBookSelectionObject: res,
          selectObj: res?.id,
          newEventId: object?.eventId,
          eventName: object?.eventName,
          marketId: object?.marketId,
          eventType: object?.eventType,
        };

        // Remove any existing bets for the same eventId
        const updatedList = current.filter(
          (bet) => bet?.newEventId !== object?.eventId
        );

        // Always add the new bet
        const finalList = [...updatedList, newObj];
        // Save in secureLocalStorage
        secureLocalStorage.setItem("parlyBet", finalList);

        return finalList;
      });
    }
  };
  const slides =
    !isEmpty(premiumDetail) || !isEmpty(premiumDetail)
      ? [{ ...premiumDetail }, { ...premiumDetail2 }, {}, {}]
      : [];

  const BettingSwiper = () => {
    return (
      slides?.length > 0 && (
        <div className="s-relative">
          <Swiper
            slidesPerView="auto"
            spaceBetween={1}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="relative"
          >
            {slides.map((slide) => (
              <SwiperSlide key={slide.id} className="slide w-80">
                {/* Slide Header */}
                <div className="w-24 h-7 py-1.5 flex text-10 leading-4 text-event-th-option text-center">
                  <div className="min-w-min w-full flex justify-center line-clamp-1 mx-px">
                    {lowerCase(slide?.marketName)?.split(" ")?.includes("x")
                      ? "1x2"
                      : lowerCase(slide?.marketName)
                          ?.split(" ")
                          ?.includes("winner")
                      ? "Winner"
                      : slide?.marketName}
                  </div>
                </div>

                {/* Odds / Placeholder */}
                <div className="relative h-3/4 flex mt-px ml-px">
                  {slide?.sportsBookSelection?.length > 0 ? (
                    <div className="w-full flex flex-col pt-px pr-px space-y-px">
                      {slide?.sportsBookSelection.slice(0, 2)?.map((res) => {
                        let obj =
                          parlyBet?.length > 0
                            ? parlyBet?.find((item) => {
                                return (
                                  item?.marketName == slide?.marketName &&
                                  item?.sportsBookSelectionObject?.odds ==
                                    res?.odds
                                );
                              })
                            : {};
                        return (
                          <div
                            onClick={() => handelPaly(slide, res)}
                            className="border-black-600 h-1/2"
                          >
                            <div
                              className={`h-full bg-black-${
                                !isEmpty(obj) ? "100" : "300"
                              } ${
                                !isEmpty(obj) ? "border" : ""
                              } rounded flex flex-col justify-center items-center`}
                            >
                              <span className="line-clamp-2 w-11/12 mx-1 text-center text-11 leading-tight">
                                {res.selectionName}
                              </span>
                              <span className="text-15 px-1 mt-px font-bold">
                                {res.odds}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <>
                      <div
                        data-v-c70ce733=""
                        class="z-10 absolute -mx-px left-0 top-0 flex justify-center items-center w-full h-full bg-black-700 opacity-80 text-11 text-white rounded-md"
                      ></div>
                      <div className="w-full flex flex-col space-y-px pr-px">
                        <div className="h-60 bg-black-300 rounded opacity-40"></div>
                        <div className="h-60 bg-black-300 rounded opacity-40"></div>
                      </div>{" "}
                    </>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )
    );
  };
  return (
    <div className="bg-white border-b border-black-100" data-index={0}>
      <div className="p-1 flex w-full border-b border-black-100">
        {slides?.length > 0 ? (
          <div className="flex flex-col w-full bg-black-100 rounded-bl">
            <div className="relative z-10 py-3.5 flex justify-end items-center bg-primary rounded-t">
              <div className="absolute w-1px h-1/2 bg-black-900 right-48" />
            </div>
            <div className="flex">
              <div className="w-full h-full flex flex-col justify-between px-2 pt-3 pb-4px">
                <div
                  onClick={() => {
                    navigate(
                      `/match-detail-velki/${object?.eventId}/${object?.marketId}/multi`
                    );
                  }}
                  className="space-y-1"
                >
                  <div>
                    <span className="break-words leading-tight">
                      {object?.eventName}
                    </span>
                  </div>
                  {/* <div className="h-10 font-bold text-widget-text">
                  <span>0 (6)</span>
                  <span className="mx-1">:</span>
                  <span>0 (6)</span>
                </div> */}
                </div>
                <div className="mt-4 flex justify-between mb-3">
                  <div className="flex gap-2px justify-start items-center">
                    <div
                      data-v-ef8204d4
                      className="inline-flex items-center h-full"
                      data-is-inplay-type="true"
                      data-is-today-type="false"
                      data-is-tomorrow-type="false"
                    >
                      <div data-v-ef8204d4 className>
                        <div
                          data-v-ef8204d4
                          className="px-3px flex items-center justify-center bg-inPlay text-white font-bold text-8 leading-9px"
                        >
                          <span data-v-ef8204d4 className="mt-1px">
                            In-Play
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <i
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleScore(object?.scoreId);
                    }}
                    className={`ml-8px text-14 ${
                      showScore?.includes(object?.scoreId)
                        ? "icon-h2h-soild"
                        : "icon-h2h"
                    }`}
                  />
                </div>
              </div>
              <div>
                <div
                  data-v-c70ce733
                  className="relative geniusParlay-content -mt-7"
                  style={{
                    "--09684924": "160px",
                    "--1c1ca16e": "7px",
                    "--5cdc6b00": "-24px",
                    "--1cbe371c": "31px",
                  }}
                >
                  <div data-v-c70ce733 className="relative h-full bg-white">
                    <div
                      data-v-c70ce733
                      className="flex h-full bg-black-100 rounded-br rounded-tr overflow-hidden"
                    >
                      <div data-v-c70ce733 className="shrink-0 w-48">
                        <BettingSwiper />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            onClick={() => {
              navigate(
                `/match-detail-velki/${object?.eventId}/${object?.marketId}/multi`
              );
            }}
            className="geniusParlay-competition-main-row grid justify-center items-center gap-1 leading-5 px-2 py-9px"
          >
            <div className="flex flex-col">
              <div className="flex gap-2px justify-start items-center">
                {object?.status == "in_play" ? (
                  <div
                    data-v-ef8204d4
                    className="inline-flex items-center h-full"
                    data-is-inplay-type="true"
                    data-is-today-type="false"
                    data-is-tomorrow-type="false"
                  >
                    <div data-v-ef8204d4 className>
                      <div
                        data-v-ef8204d4
                        className="px-3px flex items-center justify-center bg-inPlay text-white font-bold text-8 leading-9px"
                      >
                        <span data-v-ef8204d4 className="mt-1px">
                          In-Play
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    data-v-ef8204d4
                    className="inline-flex items-center h-full"
                    data-is-inplay-type="false"
                    data-is-today-type="true"
                    data-is-tomorrow-type="false"
                  >
                    <div data-v-ef8204d4 className>
                      <div
                        data-v-ef8204d4
                        className="time-block flex items-center justify-center leading-9px"
                        data-is-today-type="true"
                        data-is-tomorrow-type="false"
                      >
                        <span
                          data-v-ef8204d4
                          className="text-submenu py-px text-center text-8 px-2px pb-0"
                        >
                          {isDateToday(object?.eventDateTime)
                            ? "Today"
                            : moment(object?.eventDateTime).format(
                                "DD/MM"
                              )}{" "}
                          {moment(object?.eventDateTime).format("HH:MM")}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <p className="text-black leading-tight text-13 break-words">
                {object?.eventName}
              </p>
            </div>
            <div className="flex items-center">
              <div className="whitespace-nowrap" style={{ display: "none" }}>
                <span className="pl-1 text-13 text-right text-warning font-bold" />
                <span className="text-13 text-warning font-bold text-center mx-1.5">
                  :
                </span>
                <span className="text-13 text-warning font-bold" />
              </div>
              <i
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleScore(object?.scoreId);
                }}
                className={`ml-8px text-14 ${
                  showScore?.includes(object?.scoreId)
                    ? "icon-h2h-soild"
                    : "icon-h2h"
                } `}
              />
              <i className="icon-arrow-down text-12 ml-2 text-black-500 -rotate-90" />
            </div>
          </div>
        )}
      </div>
      {showScore?.includes(object?.scoreId) && (
        <div
          style={{ position: "relative" }}
          className="head-to-head-wrapper relative bg-LMT -mx-4 border-t-2 border-black-100 border-b"
        >
          <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleScore(object?.scoreId);
            }}
            data-v-70c0486c
            className="icon-close text-8 absolute top-7px right-5px z-10"
          />
          {displayScore({ object: object })}
        </div>
      )}
    </div>
  );
};

export default Parlay;
